import { Injectable } from '@angular/core';
import { ID } from '@datorama/akita';
import { NgEntityService } from '@datorama/akita-ng-entity-service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { Device } from '../../model/device';
import { UrlConfig } from '../../model/urlconfig';
import { HttpOptions, UpdateActionType } from '../../service/generic-akita-http.service';
import { WebsocketService } from '../../service/websocket.service';
import { DevicesState, DevicesStore } from '../state/devices.store';
import { AkitaDeviceHttpService } from './akita-device-http.service';


@UntilDestroy()
@Injectable({ providedIn: 'root' })
export class DevicesService extends NgEntityService<DevicesState> implements UrlConfig {

  constructor(
    protected store: DevicesStore,
    private deviceService: AkitaDeviceHttpService,
    private webSocketService: WebsocketService,
  ) {
    super(store);

    this.webSocketService.getDataStream('Device')
      .pipe(untilDestroyed(this))
      .subscribe((data: Device[]) => this.store.upsertMany(data));
  }
  updateEntitiesUrl(newUrl: string): void {
    this.deviceService.setEntitiesUrl(newUrl);
  }

  getAll() {
    this.deviceService.getAll().subscribe(devices =>
      // Temporarily remove the PKB test object
      this.store.upsertMany(
        devices.filter(dev => dev.attachedTo?.attachedToId !== 'urn:ngsi-ld:Building:d2d9b579-b23f-4e6a-a59c-3ae760f42a61')
      ));
  }

  getById(id: ID) {
    this.deviceService.loadById(id).subscribe(device => this.store.upsertMany([device]));
  }

  updateDeviceAction(deviceToUpdate: Device) {
    const options: HttpOptions = {
      params: {
        options: 'keyValues'
      }
    };
    const device = {
      id: deviceToUpdate.id,
      type: deviceToUpdate.type,
      action: deviceToUpdate.action
    };

    // Immediately update local store to show pending action status.
    // It will be updated again once the server responds.
    this.store.update(device.id, device);

    this.deviceService
      .update(device, UpdateActionType.APPEND, options)
      .subscribe(
        data => console.log('Updated Device', data),
        error => console.log('Error inserting in Hub', error)
      );
  }

  updateWarningDevice(ettelnSensor: Device) {
    const options: HttpOptions = {
      params: {
        options: 'keyValues'
      }
    };
    const device = {
      id: 'urn:ngsi-ld:Device:EttelnTestWarning',
      type: 'Device',
      description: `Safety Meldung: Grundwassersensor No. 2 hat den Wert ${ettelnSensor.value}`,
      dateLastValueReported: Date.now().toString()
    };

    this.store.update(device.id, device);

    this.deviceService
      .update(device, UpdateActionType.APPEND, options)
      .subscribe(
        data => console.log('Updated Warning Device', data),
        error => console.log('Error inserting in Hub', error)
      );
  }

}
